import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { Box, Card, CardContent, Container, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import React from 'react';
import '../assets/fonts/fonts.css';

const Contact = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const contactItems = [
    {
      icon: <PhoneIcon sx={{ fontSize: isMobile ? 40 : 50, color: 'primary.main' }} />,
      title: 'Appelez-nous',
      content: '07 89 20 27 11',
      link: 'tel:+33789202711',
      color: 'primary.main'
    },
    {
      icon: <EmailIcon sx={{ fontSize: isMobile ? 40 : 50, color: 'primary.main' }} />,
      title: 'Écrivez-nous',
      content: 'sascscvtc@gmail.com',
      link: 'mailto:sascscvtc@gmail.com',
      color: 'primary.main'
    },
    {
      icon: <LocationOnIcon sx={{ fontSize: isMobile ? 40 : 50, color: 'text.secondary' }} />,
      title: 'Retrouvez-nous',
      content: 'Luberon, France',
      secondContent: 'Gordes, L\'Isle-sur-la-Sorgue, Oppède',
      link: null,
      color: 'text.secondary'
    }
  ];

  return (
    <Box 
      sx={{ 
        py: { xs: 6, md: 8 },
        bgcolor: '#f5f0e5',
        borderTop: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.08)'
      }}
      id="contact"
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography 
            variant="h4" 
            align="center" 
            gutterBottom
            sx={{
              fontWeight: 600,
              mb: 4,
              color: 'primary.main',
              letterSpacing: '0.5px',
              fontFamily: '"Satisfy", cursive'
            }}
          >
            Contactez-nous
          </Typography>

          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'center',
              gap: 4,
              mb: 4
            }}
          >
            {contactItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                style={{ width: '100%' }}
              >
                <Card 
                  elevation={4}
                  sx={{ 
                    height: '100%',
                    borderRadius: 3,
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    border: index === 0 ? '2px solid' : 'none',
                    borderColor: index === 0 ? 'primary.main' : 'transparent',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: 8,
                      borderColor: 'primary.main'
                    }
                  }}
                >
                  <CardContent sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    p: 4,
                    height: '100%'
                  }}>
                    <Box sx={{ mb: 2 }}>
                      {item.icon}
                    </Box>
                    <Typography 
                      variant="h6" 
                      gutterBottom
                      sx={{ 
                        fontWeight: 600,
                        color: item.color,
                        fontFamily: '"Satisfy", cursive',
                        fontSize: '1.5rem'
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {item.link ? (
                        <Typography 
                          component="a"
                          href={item.link}
                          variant="body1"
                          sx={{ 
                            textDecoration: 'none',
                            color: 'text.primary',
                            fontWeight: 500,
                            mb: item.secondContent ? 1 : 0,
                            '&:hover': {
                              color: item.color
                            }
                          }}
                        >
                          {item.content}
                        </Typography>
                      ) : (
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            fontWeight: 500,
                            mb: item.secondContent ? 1 : 0
                          }}
                        >
                          {item.content}
                        </Typography>
                      )}
                      
                      {item.secondContent && (
                        <Typography 
                          variant="body1"
                          sx={{ 
                            color: 'text.primary',
                            fontWeight: 500,
                            fontSize: '0.95rem',
                            fontStyle: 'italic'
                          }}
                        >
                          {item.secondContent}
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Contact;
